import { ArrowUpRight } from "lucide-react";
import { COLLECTIONS, collectionUrl, formatINR } from "@/data/catalog";

export const CollectionList = ({ testPrefix }) => (
  <ul className="mt-6 divide-y divide-white/10 border-y border-white/10">
    {COLLECTIONS.map((c, i) => (
      <li key={c.slug}>
        <a href={collectionUrl(c.handle)} data-testid={`${testPrefix}-${c.slug}`} className="flex items-center gap-4 py-3">
          <img src={c.img} alt="" className="h-14 w-11 shrink-0 object-cover" style={{ objectPosition: c.pos }} loading="lazy" />
          <span className="min-w-0 flex-1">
            <span className="block font-mono text-[11px] text-stone">{String(i + 1).padStart(2, "0")} · from {formatINR(c.from)}</span>
            <span className="block truncate font-display text-xl text-cream">{c.name}{c.sub ? ` — ${c.sub}` : ""}</span>
          </span>
          <ArrowUpRight className="h-4 w-4 shrink-0 text-champagne" />
        </a>
      </li>
    ))}
  </ul>
);
